export default "__VITE_ASSET__CAwjGsuO__"